import {
  composeWithDevTools,
  composeWithDevToolsLogOnly,
} from '@redux-devtools/extension';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import create from 'redux-saga';

import { rootEffect } from './effect';
import { StoreEvent } from './event';
import { reducer } from './reducer';
import { defaultState, State } from './state';

const composeEnhancers =
  process.env.NODE_ENV === 'development'
    ? composeWithDevTools({})
    : composeWithDevToolsLogOnly({});

export function configureStore(
  { state }: { state: State } = { state: defaultState },
) {
  const saga = create();

  const store = createStore(
    reducer,
    state,
    composeEnhancers(applyMiddleware(saga)),
  );

  saga.run(rootEffect);

  return store;
}

export const useAppDispatch = useDispatch as () => (event: StoreEvent) => void;

export const useAppSelector: TypedUseSelectorHook<State> = useSelector;
